import React from 'react';

import MatchPage from '../components/match/Page';

const MatchItem = ({ pageContext }) => <MatchPage page={pageContext} />;

export default MatchItem;
